import {React, Redirect, withApollo, lockr, observable, observer, uiConstants, classObserver} from '@api'
import {ApolloClientProps} from '@api/graphql'
import { globalStores } from '@stores'
import {authStore} from '@utils'

@(withApollo as any)
@classObserver
export class LogoutContainer extends React.Component<ApolloClientProps> {
  constructor (props) {
    super(props)
  }

  componentWillMount(): void {
    if (authStore.checkIsAuthenticated()) {
      authStore.logout(false, false)
    }
  }

  render() {
    const {nav: {deploymentQueryParam}} = globalStores
    return (
      <Redirect to={`/login${deploymentQueryParam ? `?${deploymentQueryParam}` : ''}`}/>
    )
  }
}




// WEBPACK FOOTER //
// ./src/modules/logout/containers/Logout.tsx